<template>
  <div class="footer-background">

    <div class="container footer-container mobile-container">

      <div class="footer-content mobile-footer-content">
        <div class="footer-line"></div>
        <div class="footer-link">
          <div class="footer-title">快速链接</div>
          <div class="footer-content"><a class="footer-content-text" @click="toJoinUs">招贤纳士</a></div>
          <div class="footer-content"><a class="footer-content-text" @click="toCourse">PWmat教程</a></div>
          <div class="footer-content"><a class="footer-content-text" @click="toPWmatTrialDownload">PWmat试用版</a></div>
          <div class="footer-content"><a class="footer-content-text" @click="toContactUs">联系我们</a></div>
          <div class="footer-content"><a class="footer-content-text" @click="toLongxunRoom">龙讯讲坛</a></div>
        </div>
      </div>

      <div class="footer-content mobile-footer-content">
        <div class="footer-line"></div>
        <div class="footer-link">
          <div class="footer-title">友情链接</div>
          <div class="footer-content"><a class="footer-content-text" href="http://www.pkusam.com/bdm/">北大新材料</a></div>
        </div>
      </div>

      <div class="footer-content mobile-footer-content">
        <div class="footer-line"></div>
        <div class="footer-link">
          <div class="footer-title">友情链接</div>
          <div class="footer-content"><a class="footer-content-text-phone">销售电话 400-618-6006</a></div>
          <div class="footer-content"><a class="footer-content-text-phone">市场电话 13522687201</a></div>
          <div class="footer-content"><a class="footer-content-text-phone">support@pwmat.com</a></div>
        </div>
      </div>

      <div class="footer-content mobile-footer-content">
        <div class="footer-line"></div>
        <div class="footer-link">
          <div class="footer-title">公众号</div>
          <img class="foote-qrcode" src="../../assets/footer/footer-qrcode.png">
        </div>
      </div>

      <div class="footer-copyright">Copyright (c) 2020.北京龙讯旷腾科技有限公司 All rights reserved.<a class="footer-content-text" href="https://beian.miit.gov.cn/" target="_blank">京ICP备15057729号</a></div>

    </div>

  </div>
</template>

<script>
  import {COURSE_URL} from './../../helpers/consts'
export default {
  name: 'HelloWorld',
  props: {

  },
  data() {
    return {
      COURSE_URL
    }
  },
  methods:{
    toJoinUs(){
      this.$router.push({ name: 'JoinUs'})
    },
    toCourse(){
      window.location.href = this.COURSE_URL
    },
    toPWmatTrialDownload(){
      this.$router.push({ name: 'PWmatTrialDownload'})
    },
    toContactUs(){
      this.$router.push({ name: 'ContactUs'})
    },
    toLongxunRoom(){
      this.$router.push({ name: 'LongxunRoom'})
    },
  }
}
</script>

<style scoped>
  .footer-background{
    background:rgba(0,0,0,1);
    opacity:0.9;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .footer-content{
    display: inline-block;
    vertical-align: top;
    width: 277px;
    margin-top: 10px;
  }
  .footer-line{
    float: left;
    width:2px;
    height:205px;
    background:rgba(255,255,255,1);
    border-radius:11px;
  }
  .footer-link{
    margin-left: 22px;
  }
  .footer-title{
    margin-top: -4px;
    font-size:18px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:25px;
  }
  .footer-content-text{
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1) !important;
    line-height:26px;
    cursor: pointer;
  }
  .footer-content-text:hover,
  .footer-content-text:active,
  .footer-content-text:focus{
    text-decoration: underline !important;
  }
  .footer-content-text-phone{
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1) !important;
    line-height:26px;
  }
  .foote-qrcode{
    width: 140px;
    height: 140px;
    margin-top: 16px;
  }
  .footer-copyright{
    margin-top: 37px;
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:36px;
    text-align: center;
  }
  @media (max-width: 576px){
    .mobile-container{
      padding-left: 24px;
      padding-right: 24px;
    }
    .footer-background{
      background:rgba(0,0,0,1);
      padding-top: 22px
    }
    .footer-line{
      display: none;
    }
    .footer-content{
      margin-top: 2px;
    }
    .mobile-footer-content{
      margin-top: 20px;
    }
    .footer-title{
      font-size: 16px;
    }
    .footer-content-text{
      font-size: 12px;
    }

  }

  @media (min-width: 576px) and (max-width:768px) {
    .mobile-container{
      padding-left: 24px;
      padding-right: 24px;
    }
    .footer-background{
      background:rgba(0,0,0,1);
      padding-top: 22px
    }
    .footer-line{
      display: none;
    }
    .footer-content{
      margin-top: 2px;
    }
    .mobile-footer-content{
      margin-top: 20px;
    }

    .footer-content{
      width: 224px;
    }
  }

  @media (min-width: 768px) and (max-width:992px) {
    .mobile-container{
      padding-left: 24px;
      padding-right: 24px;
    }
    .footer-background{
      background:rgba(0,0,0,1);
      padding-top: 22px
    }
  }

  @media (min-width: 992px) and (max-width:1200px){

    .footer-content{
      width: 232px;
    }
  }

  @media (min-width: 1200px) {

  }
  @media screen and (max-width:482px) {

  }
  @media screen and (min-width:482px) and (max-width:768px) {

  }

</style>
